import { EVENT } from "types/socketEventsType";
import encryptAnswers from "components/helper/encryptAnswers";
import { Socket } from "socket.io-client";

const emitAsyncAnswer = async (
    socket: Socket | null,
    args: {
        votingDeviceId: string;
        publicKey: string;
        answers: { questionId: number; answer: string; weight: number }[];
    },
) => {
    if (!socket) return Promise.reject(new Error("No socket"));

    let answers: any = args.answers;
    const shouldEncryptAnswer =
        args.publicKey !== null &&
        args.publicKey !== undefined &&
        args.publicKey !== "";

    if (shouldEncryptAnswer) {
        answers = await encryptAnswers(args.publicKey, args.answers);
    }

    return new Promise<{ [key: string]: any }>((resolve, reject) => {
        socket.emit(
            EVENT.ANSWER,
            {
                votingDeviceId: args.votingDeviceId,
                answers: answers,
            },
            (res: any) => {
                if ("SUCCESS" === res.status) {
                    resolve(res.data);
                } else {
                    reject({ code: res.code, message: res.message });
                }
            },
        );
    });
};

export default emitAsyncAnswer;
